import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallButtonComponent } from './call-button/call-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    CallButtonComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    PhoneModule
  ],
  exports: [
    CallButtonComponent
  ]
})
export class CallButtonModule { }
